import React from 'react';
import './assets/css/Page.css';

export default ({ children, ...props }) => <div className="page-container">{children}</div>;
